var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.921,
    height: 58.823,
    viewBox: "0 0 64.921 58.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(-0.726 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(0.726 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M17.321,31.744h-15C.47,31.744.47,31.728.47,29.83V12.084c0-1.679.173-1.867,1.883-1.867l29.592-.047c1.993,0,2.244.267,2.275,2.244a8.8,8.8,0,0,0,0,.91c.251,1.993-.047,3.358-2.354,4.236-2.7,1.036-3.891,3.624-3.734,6.48a6.8,6.8,0,0,0,4.55,6.292c.518.2,1.475.126,1.349.926-.126.816-1.02.455-1.553.455-5.068.047-10.12.047-15.157.031Zm.816-5.852h.785c1.961,0,3.907,0,5.868-.016.408,0,.847-.094.894-.565.063-.518-.408-.612-.8-.675a12.273,12.273,0,0,0-1.679-.126c-3.781,0-7.563.031-11.344.047-.533,0-1.177-.063-1.177.643s.675.675,1.192.69Zm.11-8.128v-.078h6.245c.518,0,1.177.126,1.161-.628,0-.612-.612-.659-1.1-.659-4.268,0-8.52,0-12.788.016-.486,0-1.083.047-1.083.659,0,.722.643.69,1.177.69C13.995,17.78,16.113,17.764,18.247,17.764ZM6.056,18.6c1.663,0,1.742-.078,1.757-1.616.016-1.757-.094-1.883-1.632-1.9-1.695-.016-1.867.173-1.867,1.836C4.3,18.423,4.471,18.6,6.056,18.6ZM7.8,24.966c0-1.616-.141-1.757-1.647-1.757-1.663-.016-1.867.2-1.867,1.851,0,1.522.141,1.647,1.742,1.647C7.719,26.708,7.8,26.629,7.8,24.966Z",
    transform: "translate(-0.462 5.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M29.573,40.571c0-3.468-.016-6.951.016-10.418,0-.659-.11-1.051-.816-1.24a1.367,1.367,0,0,1-1.083-1.444,1.4,1.4,0,0,1,1.177-1.381c.643-.126.659-.486.659-1.02q0-9.955.063-19.927c.016-2.087.424-2.51,2.51-2.526,1.255-.016,2.526-.031,3.781,0,.988.031,1.883.345,1.9,1.522,0,1.161-.879,1.506-1.867,1.553-.722.047-1.459.047-2.2.047-.753,0-1.1.329-1.1,1.1q.024,9.061,0,18.122c0,.785.314,1.114,1.1,1.067a8.745,8.745,0,0,1,1.695.047,1.449,1.449,0,0,1,.078,2.887,5.915,5.915,0,0,1-.91.063c-1.946.031-1.946.031-1.946,1.914,0,5.962.031,11.909-.031,17.871-.016,1.161.361,1.569,1.491,1.475A17.349,17.349,0,0,1,36.3,50.3a1.417,1.417,0,0,1,1.522,1.459,1.365,1.365,0,0,1-1.381,1.459c-1.773.063-3.562.047-5.335-.063-1.1-.063-1.491-.847-1.491-1.93.031-3.562.016-7.123.016-10.685C29.589,40.571,29.589,40.571,29.573,40.571Z",
    transform: "translate(15.027 1.479)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M17.246,35.748H11.111a2.211,2.211,0,0,1-1.695-.5,1.294,1.294,0,0,1-.392-1.428,1.5,1.5,0,0,1,1.491-1.051c1.3-.016,2.6-.078,3.907-.016.863.031,1.255-.2,1.3-1.145.126-2.887.157-2.871-2.714-2.871-3.562.016-7.123,0-10.7,0-1.632,0-1.82-.2-1.836-1.789,0-.345.031-.69,0-1.036-.078-.926.392-1.255,1.255-1.208.22.016.439,0,.659,0h30c1.742,0,1.836.094,1.851,1.695.016,1.961-.267,2.338-1.9,2.338-3.907.016-7.829.047-11.736-.031-1.255-.016-1.789.267-1.742,1.647.078,2.463-.173,2.542,2.4,2.322a22.652,22.652,0,0,1,2.73.047c.957.047,1.647.5,1.616,1.491a1.509,1.509,0,0,1-1.679,1.475c-2.259.078-4.472.063-6.684.063Z",
    transform: "translate(-0.465 14.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M46.1,35.925c0,1.428-.016,2.871,0,4.3.016.973-.392,1.443-1.4,1.443-2.918.016-5.821.063-8.739.078a1.379,1.379,0,0,1-1.6-1.585c.031-2.871.047-5.727.031-8.6-.016-1.114.486-1.569,1.569-1.553q4.307.047,8.614,0c1.13-.016,1.553.518,1.522,1.6C46.065,33.054,46.1,34.5,46.1,35.925Z",
    transform: "translate(18.823 17.077)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M34.35,5.806c0-1.4.016-2.777,0-4.174C34.334.565,34.837-.016,35.9,0c3,.016,5.994.063,8.991.094a1.085,1.085,0,0,1,1.192,1.224V10.45c0,.879-.471,1.255-1.3,1.271H35.778a1.2,1.2,0,0,1-1.365-1.349c.016-1.522,0-3.044,0-4.55C34.4,5.806,34.382,5.806,34.35,5.806Z",
    transform: "translate(18.817 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M40.368,15.04c1.428,0,2.871.016,4.3,0a1.213,1.213,0,0,1,1.412,1.412q-.024,4.425,0,8.849a1.189,1.189,0,0,1-1.349,1.365H35.739a1.178,1.178,0,0,1-1.349-1.349q.024-4.425,0-8.849c0-.973.424-1.444,1.412-1.428C37.324,15.056,38.846,15.04,40.368,15.04Z",
    transform: "translate(18.84 8.558)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566",
    "data-name": "Path 566",
    d: "M18.93,20.881a5.92,5.92,0,0,1,5.962-5.821,6.091,6.091,0,0,1,5.852,5.868,6.124,6.124,0,0,1-6.1,5.915A6.007,6.007,0,0,1,18.93,20.881Z",
    transform: "translate(10.043 8.57)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_567",
    "data-name": "Path 567",
    d: "M22.224,21.344,20.31,18.473l.863-.581L22.585,20l4.566-2.275.471.926Z",
    transform: "translate(11.554 10.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_568",
    "data-name": "Path 568",
    d: "M37.614,21.29,35.7,18.419l.863-.581,1.412,2.1,4.566-2.291.471.941Z",
    transform: "translate(20.312 10.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_569",
    "data-name": "Path 569",
    d: "M37.7,6.654,35.79,3.783l.863-.581,1.412,2.118L42.631,3.03l.471.926Z",
    transform: "translate(20.363 1.724)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.da8171bdf5d172152fc2641ee0ea33b8.svg";
export { ForwardRef as ReactComponent };